import { BaseStatementPagePath } from 'app/core/workflow/page-path/statement-page-path/base-statement-page.path';

export class VollmachtAuthorizationComponentPath extends BaseStatementPagePath {
  public static path(): string {
    return 'statement/:statementId/vollmacht-authorization';
  }
}
